module.exports = __webpack_public_path__ + "img/AT0000002600458.cf0e2401.png";